export default __webpack_public_path__ + "static/media/signIcon.d1d7ad89.svg";